import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import './NetworkStatus.css';

const NetworkStatus = () => {
  const { networkStatus, checkServerConnection } = useAuth();
  const [serverStatus, setServerStatus] = useState('checking');
  const [showDetails, setShowDetails] = useState(false);
  const [lastChecked, setLastChecked] = useState(null);

  useEffect(() => {
    checkServer();
    
    // Check server every minute
    const interval = setInterval(() => {
      checkServer();
    }, 60000);
    
    return () => clearInterval(interval);
  }, [networkStatus]);

  const checkServer = async () => {
    if (networkStatus === 'offline') {
      setServerStatus('unavailable');
      return;
    }
    
    setServerStatus('checking');
    const isConnected = await checkServerConnection();
    setServerStatus(isConnected ? 'connected' : 'disconnected');
    setLastChecked(new Date());
  };

  if (networkStatus === 'online' && serverStatus === 'connected') {
    return null; // Don't show anything when everything is working
  }

  return (
    <div className={`network-status-container ${networkStatus}-${serverStatus}`}>
      <div className="network-status-indicator" onClick={() => setShowDetails(!showDetails)}>
        <div className="status-icon"></div>
        <div className="status-text">
          {networkStatus === 'offline' && 'नेटवर्क कनेक्शन नहीं है | No network connection'}
          {networkStatus === 'online' && serverStatus === 'disconnected' && 'सर्वर से कनेक्ट नहीं हो सका | Server unreachable'}
          {networkStatus === 'online' && serverStatus === 'checking' && 'सर्वर कनेक्शन की जांच | Checking server connection...'}
        </div>
        <div className="expand-icon">{showDetails ? '▲' : '▼'}</div>
      </div>
      
      {showDetails && (
        <div className="network-details">
          <h4>समस्या निवारण | Troubleshooting</h4>
          
          {networkStatus === 'offline' && (
            <ul>
              <li>अपने मोबाइल/वाई-फाई कनेक्शन की जांच करें | Check your mobile/WiFi connection</li>
              <li>फ्लाइट मोड बंद करें | Turn off airplane mode</li>
              <li>यदि वाई-फाई पर हैं, तो डेटा कनेक्शन पर स्विच करें | If on WiFi, try switching to data connection</li>
            </ul>
          )}
          
          {networkStatus === 'online' && serverStatus !== 'connected' && (
            <ul>
              <li>सर्वर पते की जांच करें | Check server address</li>
              <li>वाई-फाई में बदलाव करें या डेटा कनेक्शन पर स्विच करें | Try changing WiFi or switch to data</li>
              <li>ऐप को फिर से लोड करें | Reload the app</li>
            </ul>
          )}
          
          <div className="action-buttons">
            <button className="retry-btn" onClick={checkServer}>
              पुनः प्रयास करें | Retry
            </button>
            {networkStatus === 'online' && serverStatus !== 'connected' && (
              <button className="contact-admin-btn" onClick={() => window.location.reload()}>
                ऐप रीलोड करें | Reload App
              </button>
            )}
          </div>
          
          {lastChecked && (
            <div className="last-checked">
              <small>Last checked: {lastChecked.toLocaleTimeString()}</small>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default NetworkStatus; 